// Bridge between `<input type="datetime-local">` and the ISO-UTC instants the
// backend stores (HS-161, Quality Check schedule anchors).
//
// A `datetime-local` input has NO timezone: its value is a wall-clock string
// (`YYYY-MM-DDTHH:mm`) interpreted in the user's own zone. The backend stores an
// instant in UTC. These two functions are the only place that conversion happens
// — do it inline anywhere else and a user in UTC+2 sees their 14:30 check
// scheduled for 12:30.
//
// `new Date('2026-07-30T14:30')` (no offset) is parsed as LOCAL time by every
// browser, which is exactly what we want on the way in; `.toISOString()` gives
// UTC on the way out.

/** ISO-UTC instant -> the local wall-clock string the input wants. */
export function toLocalInputValue(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  // Shift by the local offset so `toISOString().slice(0,16)` yields LOCAL
  // wall-clock digits rather than UTC ones.
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
}

/** The input's local wall-clock string -> an ISO-UTC instant (or '' to clear). */
export function fromLocalInputValue(value) {
  if (!value) return '';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString();
}

/** The IANA zone name to label the picker with, so the offset is never implied. */
export function localTimeZoneLabel() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'local time';
  } catch {
    return 'local time';
  }
}
